<div class="container-fluid">
  <div class="row nav">
    <div class="col-md-12 px-4">
      <div class="d-flex align-items-center justify-content-between action-profile">
        <div
          class="neuro-pv-logo"
          (click)="openAppSwitchMenu()"
          class="logo-dropdown"
          [ngClass]="{ active: showAppSwitchDropdown }"
          (blur)="showAppSwitchDropdown = false"
          tabindex="1"
        >
          <img
            src="{{ baseHref }}/assets/images/logo_Onvida.svg"
            alt="Onvida Logo"
            style="width: 5.5rem; height: 2rem"
            class="dropbtn"
          />

          <div class="logo-dropdown-content">
            <ng-container *ngFor="let link of applinks">
              <a (click)="logoAction(link)" *ngIf="link.valid">
                <!-- <img alt="" src= {{link.icon}}
                  width="20" height="15">-->{{ link.text }}
              </a>
            </ng-container>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <span class="vl"></span>
          <div class="queuecon cursor-pointer">
            <span class="heading-1">{{ menu }}</span>
            <table style="width: 100%">
              <tr *ngIf="menu === 'Manager Console'">
                <div *ngFor="let item of stats.Console">
                  <td class="queuedet">{{ item.text }}</td>
                  <td class="queuedetval">{{ item.data }}</td>
                </div>
              </tr>
              <tr *ngIf="menu === 'Auditor Console'">
                <div *ngFor="let item of stats.Console">
                  <td class="queuedet">{{ item.text }}</td>
                  <td class="queuedetval">{{ item.data }}</td>
                </div>
              </tr>
              <tr *ngIf="queueType === 'Inbound' && menu !== 'Manager Console'">
                <div *ngFor="let item of stats.Inbound">
                  <td class="queuedet">{{ item.text }}</td>
                  <td class="queuedetval">{{ item.data }}</td>
                </div>
              </tr>
              <tr *ngIf="(queueType === 'Outbound' || queueType === 'Search') && menu !== 'Manager Console'">
                <div *ngFor="let item of stats.Others">
                  <td class="queuedet">{{ item.text }}</td>
                  <td class="queuedetval">{{ item.data }}</td>
                </div>
              </tr>
              <!-- <ng-template #elsePart>
                
              </ng-template> -->
            </table>
          </div>

          <span class="vl"></span>
          <div class="dropdown cursor-pointer" [ngStyle]="{ 'margin-right': checkDialerVisibility() ? '12rem' : '' }">
            <div class="column user-info">
              <span class="heading-2">{{ user }}</span>
              <div class="data-2 heading-2">{{ status }}</div>
            </div>

            <div
              role="presentation"
              class="column user-profile-pic user-menu-dropdown"
              (click)="openUserMenu()"
              [ngClass]="{ active: showUserMenuDropdown }"
              [ngClass]="{ disableElement: IsDisableHeader }"
              (blur)="showUserMenuDropdown = false"
              tabindex="2"
            >
              <img alt="" class="user-pic" [src]="URL" alt="User Icon" id="imgAvatar" />
              <div class="voice-mail-count voicemail-div" *ngIf="VoiceMailCount > 0">
                {{ VoiceMailCount }}
              </div>
              <div class="user-menu-dropdown-content" [hidden]="!showUserMenuDropdown">
                <ng-container *ngFor="let link of _qbr_linkArray">
                  <a role="presentation" (click)="menuAction(link)" *ngIf="link.display">
                    <img alt="" src="{{ link.icon }}" width="20" height="15" />
                    {{ link.text }}
                  </a>
                </ng-container>
              </div>
            </div>
          </div>
          <app-dialer
            *ngIf="HideShowDialer()"
            class="hdr-app-dialer"
            (showCallDialerOut)="CallDialerVisibility($event)"
            (conferenceWindowOpened)="conferenceWindowStatus($event)"
            [ngClass]="getCallTransferStatus() || isConferenceWindowOpen ? 'dialer-index' : ''" 
          >
          </app-dialer>
          <!-- <app-dialer *ngIf="HideShowDialer()" style="width: 11.25rem"> </app-dialer>  -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="getCallAlertStatus()" style="padding-bottom: 2px;">
      <div class="row" style="background-color: yellow;height: 2rem;border: 1px solid red;">
        <div class="col-sm"></div>
          <div class="col-sm" style="height: 100%;text-align: center;">
            <label class="mr-1" style="color: black"><b>{{IncomingCallAlerttext}}</b></label>
          </div>
          <div class="col-sm" style="height: 100%;text-align: right;">
             <label class="mr-1" style="color: black" *ngIf="!isBlendedManual"><b>{{countdownField}}</b></label>
            <button (click)="answerCall()" class="outline-btn mr-1">
              <img src="{{ baseHref }}/assets/images/icon-inbound.svg" style="height: 0.813rem;"/>
                <b>Answer</b>
            </button>
            <button  (click)="rejectCall()" class="outline-btn" *ngIf="!isBlendedManual">
              <img src="{{ baseHref }}/assets/images/icon-inbound.svg" style="height: 0.813rem;"/>
              <b>Reject</b>
            </button>
          </div>  
      </div>
</div>
<app-menu [IsDisableHeader]="IsDisableHeader"></app-menu>
